export const SB_KIT_VERSION = 1;
export const SB_STAGES = ['mood', 'plan', 'built'];
export const SB_HISTORY_ID = 'sb-history';
/**
 * Notes for the whole video (<sb-video-notes>; the kit adds one to the Send bar of every page that takes input):
 * the `video` field, read by the agent with scope "video". `note` is the free note; the rest are the prompts the
 * agent can act on (the story or angle, who it is for, the tone, the length, a fact to add, a source to use).
 */
export const SB_VIDEO_FIELD = 'video';
export const SB_VIDEO_TOPICS = ['note', 'story', 'audience', 'tone', 'length', 'add', 'source'];
export const SB_VIDEO_NOTE_MAX_CHARS = 2000;
export const SB_VIDEO_NOTES_MAX = 12;
export const SB_THEME_MODES = ['light', 'dark', 'system'];
export const SB_KIT_TO_HOST = ['sb:ready', 'sb:resolve', 'sb:changed', 'sb:send', 'sb:open', 'sb:fetch', 'sb:set-theme', 'sb:navigate', 'sb:size', 'sb:narration', 'sb:see-looks'];
/** A resolved media URL with this prefix cannot play where the page is shown; the kit offers to open the rest of it (a no-login link) instead. */
export const SB_OPEN_PREFIX = 'sb-open:';
/** …and with this one it plays here once fetched: the kit shows Play, and on a click asks the host to fetch it (sb:fetch → sb:fetched with the bytes). */
export const SB_PLAY_PREFIX = 'sb-play:';
export const SB_HOST_TO_KIT = ['sb:resolved', 'sb:sent', 'sb:error', 'sb:seek', 'sb:fetched', 'sb:theme', 'sb:host', 'sb:ivy', 'sb:look-chosen'];
function fieldSummary(name, value) {
    if (Array.isArray(value) && value.length && typeof value[0] === 'object') {
        return `${name}×${value.length}`;
    }
    if (value && typeof value === 'object' && !Array.isArray(value) && 'ops' in value) {
        const n = value.ops.length;
        return `${name}(${n} op${n === 1 ? '' : 's'})`;
    }
    return name;
}
export function formatStoryboardInputLine(input) {
    const names = input.touched.length ? input.touched : Object.keys(input.fields);
    const parts = [...names].sort().map((n) => fieldSummary(n, input.fields[n]));
    const lock = input.lock ? ' · lock' : '';
    return `[storyboard input ${input.id} · v${input.storyboardVersion} · fields: ${parts.join(', ')}${lock}]`;
}
export const STORYBOARD_INPUT_LINE = /^\[storyboard input (in_\d+) · v(\d+) · fields: [^\]]*\]/;
